import { useSelector } from 'react-redux';

// Simple hook to get tenancy lookup from Redux
export const useTenancyLookup = () => {
    const tenancyLookup = useSelector((state) => state.tenancy.tenancyLookup);

    return {
        tenancyLookup,
        resolveTenancyName: (tenancyId) => {    
            const id = parseInt(tenancyId, 10);
            return tenancyLookup[id] || `Tenancy ${tenancyId}`;
        }
    };
};
